const tableTitleTableActions = {
  title: 'Actions',
  placeholder: 'Search by the fields: ID, action, issue, question',
};

export default tableTitleTableActions;
